@if (vm$ | async; as vm) {
  <div class="page-title__title">{{ vm.title }}</div>
  <div class="page-title__subtitle">{{ vm.subtitle }}</div>
  <div class="page-title__bottom-border"></div>
}
